import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountPPICloseSuccessPage} from '../../../../../../../features/credit/pages/CreditAccountPPIClosePage/CreditAccountPPICloseSuccessPage';

export const Route = createFileRoute(
  '/_protected/accounts/credits/$accountId/ppi/close/success',
)({
  component: CreditAccountPPICloseSuccessPage,
});
